import styles from './form-button-row.module.css';
import { Button, ButtonLinkProps, RegularButtonProps } from '@/components/button';
import { useTranslation } from '@/contexts/i18n-context';
import { useEncounter } from '@/contexts/encounter-context';
import { FormButtonRow, FormButtonRowProps } from './form-button-row';
import { TranslationKey } from '@/contexts/translations';
import { useVisitNavigation } from '@/contexts/visit-navigation-context';

type VisitFormButtonRowProps = FormButtonRowProps & {
  showNextButtonOnReview?: boolean;
  reviewButtonTextKey?: TranslationKey;
  description?: never;
};

export function VisitFormButtonRow({
  nextStep,
  buttonTextKey,
  className,
  rightIcon,
  showNextButtonOnReview = false,
  ...restProps
}: VisitFormButtonRowProps) {
  const { editMode } = useVisitNavigation();

  return editMode && !showNextButtonOnReview ? (
    <ReviewFormButtonRow {...restProps} />
  ) : (
    <FormButtonRow
      {...restProps}
      nextStep={!showNextButtonOnReview ? nextStep : undefined}
      buttonTextKey={buttonTextKey}
      className={className}
      rightIcon={rightIcon}
    />
  );
}

type ReviewProps = {
  secondaryButton?: React.ReactNode;
  reviewButtonTextKey?: TranslationKey;
};

type ReviewFormButtonRowProps =
  | (Omit<RegularButtonProps, 'children' | 'rightIcon'> & ReviewProps)
  | (Omit<ButtonLinkProps, 'children' | 'rightIcon'> & ReviewProps);

function ReviewFormButtonRow(props: ReviewFormButtonRowProps) {
  const { t } = useTranslation();
  const { encounter } = useEncounter();
  const { editMode } = useVisitNavigation();

  return (
    <div className={styles.formButtonRow}>
      {props.secondaryButton ?? (
        <Button
          variant="outlined"
          color="accent"
          as="a"
          to={`/visit/${encounter.id}/review`}
          state={{ editMode }}
        >
          {t('visit.review.cancelChanges')}
        </Button>
      )}
      <Button {...props} color="accent">
        {t(props.reviewButtonTextKey ?? 'common.saveChanges')}
      </Button>
    </div>
  );
}
